import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-left">
          <div className="footer-brand">Codenest</div>
          <div className="footer-made">Made by Veda • 2026</div>
        </div>

        <nav className="footer-nav">
          <a href="/privacy" className="footer-link">Privacy Policy</a>
          <a href="/terms" className="footer-link">Terms of Service</a>
          <a href="mailto:rajderkarved19@gmail.com" className="footer-link">Contact</a>
        </nav>

        <div className="footer-right">
          <div className="footer-secondary">
            <a href="https://vedvortex.netlify.app/" target="_blank" rel="noopener noreferrer" className="secondary-link">About</a>
            <a href="/docs.pdf" target="_blank" rel="noopener noreferrer" className="secondary-link">Docs</a>
          </div>
          <div className="footer-contact">rajderkarved19@gmail.com</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
